import React from 'react';
import { InfoButton } from '@markinson/uicomponents-v2';

export const InfoCellComponent = (props) => {
    const rowData = props?.data;

    const handleClick = (e) => {
        e.stopPropagation();
        props.onInfoClick?.(rowData);
    };

    return (
        <div onClick={handleClick} style={{ cursor: 'pointer' }}>
            <InfoButton />
        </div>
    );
};
